import styled from 'styled-components'

export const PerformanceGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const PerformanceCard = styled.div`
  ${(props) => props.theme.content};
  padding: 1.25rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  min-height: 14rem;
`

export const PerformanceCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  .header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .title {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) => props.theme.textColor};
  }

  .source {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${(props) => props.theme.greyText};
    font-weight: 500;
  }
`

export const PerformanceStatsRow = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
`

export const PerformanceStatCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${(props) => props.theme.greyText};
    font-weight: 500;
  }

  .value-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  .value {
    font-size: 22px;
    font-weight: 700;
    color: ${(props) => props.theme.textColor};
  }

  .change-positive {
    font-size: 12px;
    font-weight: 600;
    color: #24d07b;
  }

  .change-negative {
    font-size: 12px;
    font-weight: 600;
    color: #ff4f46;
  }

  .sub-label {
    font-size: 11px;
    color: ${(props) => props.theme.greyText};
  }
`

export const PerformanceFootnote = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  font-size: 12px;

  .item {
    color: ${(props) => props.theme.textColor};

    .num {
      font-weight: 700;
    }

    &.no-show .num {
      color: #ff4f46;
    }

    &.late .num {
      color: #ff9900;
    }

    &.early .num {
      color: ${(props) => props.theme.textColor};
    }
  }
`

export const PerformanceDailyBars = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 3rem;
  width: 100%;
`

export const PerformanceDailyBar = styled.div<{ status?: number }>`
  flex: 1;
  min-width: 4px;
  border-radius: 3px;
  background: ${(props) => {
    switch (props.status) {
      case 1:
        return '#24D07B'
      case 2:
        return '#FF4F46'
      case 3:
        return '#FF9900'
      case 4:
        return '#00A6FF'
      default:
        return '#3C3C3C'
    }
  }};
  height: ${(props) => {
    switch (props.status) {
      case 1:
        return '100%'
      case 2:
        return '40%'
      case 3:
        return '70%'
      case 4:
        return '60%'
      default:
        return '30%'
    }
  }};
`

export const PerformanceDonutContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`

export const PerformanceLegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 10rem;
`

export const PerformanceLegendRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 2px;
  }

  .name {
    color: ${(props) => props.theme.textColor};
  }

  .pct {
    color: ${(props) => props.theme.textColor};
    font-weight: 600;
  }
`

export const PerformanceMachineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${(props) => props.theme.colorDividerDefault};
  }

  .text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .name {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.textColor};
  }

  .role {
    font-size: 12px;
    color: ${(props) => props.theme.greyText};
  }

  .hours {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.textColor};
  }
`

export const PerformanceCertificateAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #ff9900;
  background: rgba(255, 153, 0, 0.06);

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${(props) => props.theme.textColor};
    font-size: 13px;

    .name {
      font-weight: 600;
    }

    .expires {
      color: ${(props) => props.theme.greyText};
    }
  }

  .action {
    color: #ff9900;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border: 1px solid #ff9900;
    border-radius: 8px;
    cursor: pointer;
    background: transparent;
  }
`

export const ListSidebarGrid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const ListTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ListTableHeader = styled.div<{ columns?: string }>`
  display: grid;
  grid-template-columns: ${(props) => props.columns ?? '2fr 1fr 1fr 1fr'};
  padding: 0 1rem 0.75rem 1rem;
  gap: 0.75rem;

  span {
    font-size: 11px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: ${(props) => props.theme.greyText};
    font-weight: 500;
  }
`

export const ListTableRow = styled.div<{ columns?: string }>`
  ${(props) => props.theme.content};
  display: grid;
  grid-template-columns: ${(props) => props.columns ?? '2fr 1fr 1fr 1fr'};
  align-items: center;
  padding: 0.875rem 1rem;
  gap: 0.75rem;
  margin-bottom: 0.625rem;
  border-radius: 10px;
  cursor: pointer;
  transition: outline 0.2s ease;

  &:hover {
    outline: 1px solid ${(props) => props.theme.colorOrange};
  }

  span {
    font-size: 13px;
    color: ${(props) => props.theme.textColor};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .right {
    text-align: right;
  }
`

export const SidePanelCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  .panel-title {
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => props.theme.textColor};
  }
`

export const PreviewModalGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`

export const PreviewModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    font-size: 12px;
    color: ${(props) => props.theme.textColor};
  }

  .value {
    border: 1px solid ${(props) => props.theme.colorDividerDefault};
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    color: ${(props) => props.theme.textColor};
    font-size: 13px;
    min-height: 2.25rem;
    display: flex;
    align-items: center;
  }
`

export const PreviewModalLink = styled.a`
  font-size: 13px;
  color: ${(props) => props.theme.textColor};
  text-decoration: underline;
  cursor: pointer;
`
